import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import i18next from 'i18next';
import { enqueueNotification } from 'actions/uiActions';
import { makeApiUrl } from 'actions/_shared/utils';
import { Store } from 'store/storeTypes';

// shared status/download endpoints, independent of which report (ink consumption per job,
// errors and maintenance, ...) the job generates - see JobAnalysisReportController on the server
export const asyncReportJobStatusUrl = (jobId: string) =>
  makeApiUrl(`/api/job-analysis-report/async-report-jobs/${jobId}/status`);
export const asyncReportJobDownloadUrl = (jobId: string) =>
  makeApiUrl(`/api/job-analysis-report/async-report-jobs/${jobId}/download`);

export const ASYNC_REPORT_JOB_POLLING_INTERVAL_MS = 10 * 1000;
const ASYNC_REPORT_JOB_POLLING_TIMEOUT_MS = 30 * 60 * 1000;
const ASYNC_REPORT_JOB_PROCESSING_MESSAGE_KEYS = [
  'asyncReportJob.jobProcessing',
  'asyncReportJob.jobStillProcessing',
  'asyncReportJob.jobDownloadWhenReady',
];

const asyncReportJobPollingTimers: Partial<Record<string, ReturnType<typeof setTimeout>>> = {};

export const clearAsyncReportJobPolling = (pollingKey: string) => {
  clearTimeout(asyncReportJobPollingTimers[pollingKey]);
  delete asyncReportJobPollingTimers[pollingKey];
};

export const scheduleAsyncReportJobPoll = (pollingKey: string, poll: () => void) => {
  asyncReportJobPollingTimers[pollingKey] = setTimeout(poll, ASYNC_REPORT_JOB_POLLING_INTERVAL_MS);
};

export const isAsyncReportJobPollingTimedOut = (startedAt: number) =>
  Date.now() - startedAt > ASYNC_REPORT_JOB_POLLING_TIMEOUT_MS;

export const notifyAsyncReportJobProcessing = (
  dispatch: ThunkDispatch<Store, any, Action>,
  attempt: number
) => {
  const messageKey =
    ASYNC_REPORT_JOB_PROCESSING_MESSAGE_KEYS[attempt % ASYNC_REPORT_JOB_PROCESSING_MESSAGE_KEYS.length];
  dispatch(
    enqueueNotification(i18next.t(messageKey), {
      variant: 'success',
      autoHideDuration: ASYNC_REPORT_JOB_POLLING_INTERVAL_MS - 1000,
    })
  );
};

export const notifyAsyncReportJobError = (
  dispatch: ThunkDispatch<Store, any, Action>,
  message: string
) => dispatch(enqueueNotification(message, { variant: 'error' }));

export const getAsyncReportJobFailedMessage = () => i18next.t('asyncReportJob.jobFailed');
export const getAsyncReportJobTimeoutMessage = () => i18next.t('asyncReportJob.jobTimeout');
